import { z } from "zod";
import { defineStepConfig } from "../registry/helpers";
import { actionBoundaryConfigSchema } from "../utils/action-interfaces";
import { workflowExecutionTimeoutSchema } from "../utils/workflowExecutionTimeout";

export const actionInputStep = defineStepConfig({
  type: "action_input",
  name: "Action Input",
  description:
    "Entry point for reusable workflow actions. Output sockets are derived from connected downstream inputs.",
  category: "Trigger",
  inputSchema: z.never(),
  outputSchema: z.record(z.string(), z.unknown()),
  // A run started on demand can run long (a loop over hundreds of items one at a
  // time), so this trigger, like the event triggers, can raise the 1-hour default.
  configSchema: actionBoundaryConfigSchema.extend({
    workflowExecutionTimeout: workflowExecutionTimeoutSchema,
  }),
  emits: [] as const,
});
